export const governanceTags = {
  '$schema': 'http://json-schema.org/draft-04/schema#',

  'definitions': {
    'privacyDetail': {
      'title': 'Details about the privacy contract for the underlying data payload',
      'type': 'object',
      'properties': {
        'version': {
          '$ref': 'com.hp.cdm.domain.glossary.version.1.schema.json#/definitions/version'
        },
        'privacyBases': {
          'type': 'array',
          'maxItems': 50,
          'indexProperty': 'basis',
          'items': {
            'type': 'object',
            'properties': {
              'basis': {
                'type': 'string',
                'enum': [
                  'classic',
                  'classicEnterprise',
                  'hpOwned',
                  'appBasicDataCollection',
                  'appAnalytics',
                  'appAdvertising',
                  'appPersonalized',
                  'printerBasicDataCollection',
                  'printerAnalytics',
                  'printerAdvertising',
                  'printerPersonalized',
                  'psAdvertising',
                  'psAnalytics',
                  'psBasicDataCollection',
                  'serviceBasicDataCollection',
                  'webCookieBasicDataCollection',
                  'webCookieAnalytics',
                  'webCookieAdvertising',
                  'webCookiePersonalized'
                ]
              },
              'basisVersion': {
                'type': 'string',
                'pattern': '^\\d+\\.\\d+$'
              }
            },
            'required': [
              'basis',
              'basisVersion'
            ],
            'additionalProperties': false
          }
        },
        'dataPurposes': {
          'type': 'array',
          'maxItems': 20,
          'items': {
            'type': 'string',
            'enum': [
              'benefitsCustomer',
              'benefitsHp',
              'benefitsHpAnalytics',
              'benefitsHpAnalyticsAggregate',
              'benefitsHpPersonalized',
              'benefitsHpWithPet',
              'advertising',
              'limitedUseFlag'
            ]
          }
        }
      },
      'required': [
        'version',
        'privacyBases',
        'dataPurposes'
      ],
      'additionalProperties': false
    }
  },
  'gun': 'com.hp.cdm.domain.privacy.type.governanceTags.version.1',
  'type': 'object',
  'version': '1.4.0',
  'description': 'Adding new support for common consents',
  'id': 'https://schemaregistry.analysis.ext.hp.com/cdm/gun/com.hp.cdm.domain.privacy.type.governanceTags.version.1.schema.json',
  'jsonSchemaGun': 'com.hp.cdm.domain.privacy.type.governanceTags.version.1.schema.json',
  'additionalProperties': false
};
